import { queryOptions } from "@tanstack/react-query";
import { fetchOccPageData } from "./pageDataClient";
import { pageDataKeys } from "./pageDataKeys";
import type { PageInitialDataResult } from "./pageInitialDataTypes";
import type { MediaLibraryPageInitialData } from "./mediaLibraryPageInitialData";

export const mediaLibraryPageQueryOptions = () =>
  queryOptions({
    queryKey: pageDataKeys.mediaLibrary(),
    queryFn: () => fetchOccPageData<PageInitialDataResult<MediaLibraryPageInitialData>>("/page-data/media-library"),
    staleTime: 0,
    gcTime: 0,
    refetchOnWindowFocus: false,
    retry: 1,
  });
